import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {IDatepickerSchema, indicate, ToastService} from "maps-angular-components";
import {Subject, Subscription} from "rxjs";

import {BrowserSupport} from "../util/browser-support";
import {LogImportacaoLote} from "./log-importacao-lote";
import {ImportacaoLoteService} from "./importacao-lote.service";
import {finalize} from 'rxjs/operators';
import {ConstantsService} from "../services/constants.service";
import {TipoUpload} from "./tipo-upload";

@Component({
    selector: 'app-importacao-lote',
    templateUrl: './importacao-lote.component.html',
  styleUrls: ['./importacao-lote.component.scss']
})
export class ImportacaoLoteComponent implements OnInit {
  private readonly subscriptions = new Subscription();
  public loading$ = new Subject<boolean>();

  formPesquisa: FormGroup;
  file: File = null;
  @ViewChild('fileInput', {static: false}) formUpload;

  page$: Subject<number> = new Subject<number>();

  private pageNumber = 1;
  private pageSize = 20;
  paginationTotalPage = 0;
  isLoading = false;
  totalRegistros = 0;
  showExecutar = true;
  logs: LogImportacaoLote[];
  readOnly = false;
  INPUT_MESSAGE = 'Clique ou arraste o arquivo';
  currentFileName = this.INPUT_MESSAGE;
  semPermissaoExecutar: boolean = false;
    semPermissaoListar: boolean = false;
    private constantes: any;
    @Output()
    private onBaixarModelo = new EventEmitter();
    @Input() private  tipo : TipoUpload;
    public dataInicioSchema: IDatepickerSchema;
    public dataFimSchema: IDatepickerSchema;

    constructor(
        private fb: FormBuilder,
        private messageService: ToastService,
        private constantsService: ConstantsService,
        private importacaoService: ImportacaoLoteService,
        private readonly changeDetectorRef: ChangeDetectorRef,
    ) {
    }

    ngOnInit() {
        this.formPesquisa = this.fb.group({
            usuario: new FormControl('', []),
            page: new FormControl(0),
            itensPerPage: new FormControl(20),
            status: new FormControl(),
        });

        this.dataInicioSchema = {
            label: "Data início",
            placeholder: "Selecione uma data",
            formGroup: this.formPesquisa,
            panelClass: "w-100",
            formControlName: "inicio",
            required: true,
            value: new Date()
        };

        this.dataFimSchema = {
            label: "Data fim",
            placeholder: "Selecione uma data",
            formGroup: this.formPesquisa,
            panelClass: "w-100",
            formControlName: "fim",
            required: true,
            value: new Date()
        };

        if (this.semPermissaoListar) {
            this.formPesquisa.disable();
        }
        this.subscriptions.add(this.constantsService.findConstants().subscribe(result => this.constantes = result));
    }

    receiverPage(e) {
        this.formPesquisa.get('page').setValue(e - 1);
        this.pesquisar(this.formPesquisa.value);
    }

    downloadXlsxCompleto(l: any) {
        this.importacaoService.downloadXLSXCompleto(l.identificador)
        .pipe(indicate(this.loading$))
        .subscribe(
            (response) => {
                const contentDisposition = response.headers.get('Content-Disposition');
                const fileName = contentDisposition.split(';')[1].split('filename')[1].split('=')[1].trim();
                BrowserSupport.saveAs(new Blob([response.body]), fileName);
                this.messageService.sucesso('Exportação realizada com sucesso.');
            },
            e => {
                this.messageService.erro(`${e}`)
            }
        );
    }


    dowloadStack(l: any) {
        this.importacaoService.downloadStack(l.identificador)
        .pipe(indicate(this.loading$))
        .subscribe(
            (response) => {
                BrowserSupport.saveTextFile(response);
                this.messageService.sucesso('Exportação realizada com sucesso.');
            },
            e => {
                this.messageService.erro(`${e}`)
            }
        );
    }

    downloadModelo() {
        this.onBaixarModelo.emit();
    }

    pesquisar(form, pageSearch = false) {
        if (!pageSearch) {
          this.formPesquisa.controls.page.setValue(0);
          this.page$.next(this.pageNumber);
        }
        this.logs = [];

        this.subscriptions.add(
            this.importacaoService
            .search(form,this.tipo, this.pageSize)
            .pipe(indicate(this.loading$))
            .subscribe(
                res => {
                    if (res.metadata.totalElements > 0) {
                        if (res.metadata.size === 0) {
                            this.paginationTotalPage = 1;
                        } else {
                            this.paginationTotalPage = Math.ceil(
                                res.metadata.totalElements / res.metadata.size
                            );
                        }
                        this.totalRegistros = res.metadata.totalElements;
                        this.logs = res.content;
                        this.formPesquisa.get("page").setValue(res.metadata.number);
                    } else {
                        this.paginationTotalPage = 1;
                    }
                    this.changeDetectorRef.detectChanges();
                },
                err => this.messageService.erro(err.error.message)
            )
        );
    }

    nameButtonProcess() {
        return this.showExecutar ? 'Executar' : 'Processando arquivo ...';
    }

    isFileSelected(): boolean {
        return (this.file !== null);
    }

    isExtensionValid(filename: string): boolean {
        const validExts = ['.xlsx', '.xls', '.zip'];
        filename = filename.substring(filename.lastIndexOf('.'));
        return !(validExts.indexOf(filename) < 0);
    }

    resetFile() {
        this.file = null;
        this.currentFileName = this.INPUT_MESSAGE;
        if (this.formUpload) {
            this.formUpload.nativeElement.value = null;
        }
    }

    uploadFile(event: FileList) {
        if (this.readOnly) {
            return;
        }
        if (!this.isExtensionValid(event[0].name)) {
            this.messageService.erro(`Somente extensões [.xlsx], [.xls] e [.zip] são válidas.`);
            return;
        }
        this.file = event[0];
        const fileSizeFormated = BrowserSupport.formatBytes(this.file.size);
        this.currentFileName = `${this.file.name} (${fileSizeFormated})`;
    }

    importar() {
        if (!this.isFileSelected) {
            this.messageService.info('Nenhuma planilha/zip selecionada');
            return;
        }
        this.showExecutar = false;
        this.isLoading = true;
        this.importacaoService.importar(this.file,this.tipo)
        .pipe(
            finalize(() => {
                this.isLoading = false;
                this.showExecutar = true;
                this.pesquisar(this.formPesquisa.value);
            }))
        .subscribe(
            (resp) => {
                this.resetFile();
                this.messageService.sucesso('Planilha/Zip enviada com sucesso.');
            },
            (error => {
                this.isLoading = false;
                this.resetFile();
                this.messageService.erro(`Erro ao importar planilha/zip: ${error}`);
            }));
    }

    updatePesquisa() {
        this.pesquisar(this.formPesquisa.value);
    }

    parseStatus(status: string) {
        return this.constantes[status];
    }
}
